export const QUERY_STATUS = {
  ACTIVE: 1,
  EXPIRED: 2,
  SUSPENDED: 2,
  REVOKED: 3,
  LOGOUT: 9,
  INACTIVE: 9,
};

export const GENERAL_STATUS = {
  ACTIVE: 1,
  INACTIVE: 9,
};

export const USER_STATUS = {
  ACTIVE: 1,
  SUSPENDED: 2,
  INACTIVE: 9,
} as const;

export const ERROR_TYPE = {
  maintenanceMode: 'maintenanceMode',
  authentication: 'authentication',
};

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
